import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeeService } from './logic/employee.service';
import { EmployeeLogicService } from './logic/employee/employee-logic.service';
import { EmployeeDaoService } from './dao/employee-dao.service';
import { EmployeeDBDaoService } from './dao/employee-dao/employee-db-dao.service';
import { EmployeeDbTableDefinition } from './dao/employee-dao/employee-db-table-definition';
import { TeamEmployeeDbTableDefinition } from './dao/employee-dao/team-employee-db-table-definition';
@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: EmployeeService, useClass: EmployeeLogicService },
    { provide: EmployeeDaoService, useClass: EmployeeDBDaoService },
    { provide: EmployeeDbTableDefinition },
    { provide: TeamEmployeeDbTableDefinition },
  ]
})
export class EmployeeModule {}
